module.exports = __webpack_public_path__ + "img/wymiana-opon-i-kol.235c8146.jpg";